import script from "./UserRow.vue?vue&type=script&setup=true&lang=js"
export * from "./UserRow.vue?vue&type=script&setup=true&lang=js"

import "./UserRow.vue?vue&type=style&index=0&id=1926c56c&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1926c56c"]])

export default __exports__